module.exports = __webpack_public_path__ + "img/htc-icon.9dfbb4a4.svg";